export enum EPsrCameraLiveImageAction {
  SET_SHOW_CROSSHAIR = "SET_SHOW_CROSSHAIR",
  SET_SHOW_RULER = "SET_SHOW_RULER",
  SET_LIVE_IMAGE_CROP_ZOOM = "SET_LIVE_IMAGE_CROP_ZOOM",
  SET_IMAGE_BEST_FIT = "SET_IMAGE_BEST_FIT",
  SET_CURSOR_OFFSET = "SET_CURSOF_OFFSET",
}

export interface CursorOffset {
  x: number,
  y: number
}

export interface PsrCameraLiveImageAction {
  type: EPsrCameraLiveImageAction;
  showCrosshair?: boolean;
  showRuler?: boolean;
  liveImageCropZoomX?: number;
  liveImageCropZoomY?: number;
  bestFit?: boolean;
  cursorOffset?: CursorOffset;
}

export function setShowCrossHair(showCrosshair: boolean): PsrCameraLiveImageAction {
  return {
    type: EPsrCameraLiveImageAction.SET_SHOW_CROSSHAIR,
    showCrosshair: showCrosshair,
  };
}

export function setShowRuler(showRuler: boolean): PsrCameraLiveImageAction {
  return {
    type: EPsrCameraLiveImageAction.SET_SHOW_RULER,
    showRuler: showRuler,
  };
}

export function setLiveImageCropZoom(x: number, y: number): PsrCameraLiveImageAction {
  return {
    type: EPsrCameraLiveImageAction.SET_LIVE_IMAGE_CROP_ZOOM,
    liveImageCropZoomX: x,
    liveImageCropZoomY: y,
  };
}

export function setImageBestFit(bestFit: boolean): PsrCameraLiveImageAction {
  return {
    type: EPsrCameraLiveImageAction.SET_IMAGE_BEST_FIT,
    bestFit: bestFit,
  };
}

export function setCursorOffset(cursorOffset: CursorOffset): PsrCameraLiveImageAction {
  return {
    type: EPsrCameraLiveImageAction.SET_CURSOR_OFFSET,
    cursorOffset: cursorOffset,
  };
}

